import { render, staticRenderFns } from "./ForestersTemp.vue?vue&type=template&id=e4321aae&scoped=true"
import script from "./ForestersTemp.vue?vue&type=script&lang=js"
export * from "./ForestersTemp.vue?vue&type=script&lang=js"
import style0 from "./ForestersTemp.vue?vue&type=style&index=0&id=e4321aae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4321aae",
  null
  
)

export default component.exports